export const bookingStats = {
  totalBookings: 3,
  upcoming: 1,
  today: 0,
  completed: 0,
};

export const requests = [
  {
    id: "BK-001",
    initials: "DA",
    name: "Dr. Ananya Reddy",
    specialty: "Additive Manufacturing",
    date: "28 Jul 2026",
    time: "6:00 PM - 7:00 PM",
    location: "Online",
    email: "ananya.reddy@iittp.ac.in",
    mobile: "+91 98765 43210",
  },
  {
    id: "BK-002",
    initials: "PK",
    name: "Prof. Karthik Iyer",
    specialty: "Robotics & Mechatronics",
    date: "30 Jul 2026",
    time: "5:30 PM - 6:15 PM",
    location: "Online",
    email: "karthik.iyer@iiits.in",
    mobile: "+91 98450 12345",
  },
  {
    id: "BK-003",
    initials: "RV",
    name: "Rahul Varma",
    specialty: "EV Powertrain",
    date: "2 Aug 2026",
    time: "4:00 PM - 5:00 PM",
    location: "Online",
    email: "rahul.varma@ashokleyland.com",
    mobile: "+91 97890 11223",
  },
];

export const upcoming = [
  {
    id: "BK-003",
    initials: "RV",
    name: "Rahul Varma",
    specialty: "EV Powertrain",
    date: "2 Aug 2026",
    time: "4:00 PM - 5:00 PM",
    location: "Online",
    email: "rahul.varma@ashokleyland.com",
    mobile: "+91 97890 11223",
  },
];

export const orderHistory = [
  {
    id: "OH-001",
    initials: "MS",
    name: "Meera Sundaram",
    specialty: "PCB & Embedded Design",
    date: "14 Jun 2026",
    time: "10:00 AM - 10:45 AM",
    price: 1200,
    rating: 5,
    status: "Completed",
  },
  {
    id: "OH-002",
    initials: "DA",
    name: "Dr. Ananya Reddy",
    specialty: "Additive Manufacturing",
    date: "20 May 2026",
    time: "6:00 PM - 7:00 PM",
    price: 1500,
    rating: 4,
    status: "Completed",
  },
  {
    id: "OH-003",
    initials: "PK",
    name: "Prof. Karthik Iyer",
    specialty: "Robotics & Mechatronics",
    date: "2 May 2026",
    time: "5:30 PM - 6:15 PM",
    price: 1800,
    rating: null,
    status: "Cancelled",
  },
];